export default __webpack_public_path__ + "static/media/temperature-control.0cd17e6d.svg";